<template>
  <component :is="component">
    <!-- String children -->
    <div v-if="typeof children === 'string'" v-html="children"></div>
    <!-- Array children -->
    <template v-if="typeof children === 'array'">
      <InpupSlot
        v-for="(slot, i) in children"
        v-bind="slot.props"
        :key="`input-slot-children-${i}`"
        :component="slot.component"
        :children="slot.children"
      />
    </template>
  </component>
</template>

<script>
export default {
  props: {
    component: {
      type: String,
      default: 'div',
    },
    children: {
      type: [String, Array],
      default: '',
    },
  },
};
</script>
